var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:{ night: _vm.isNight }},[(_vm.name)?_c('h2',{staticClass:"name"},[_vm._v(_vm._s(_vm.name)),_c('span',[_vm._v("さん")])]):_c('h2',{staticClass:"name"},[_vm._v("観戦中")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }